/* eslint-disable */
import Vue from 'vue'
import Router from 'vue-router'

// components
import Dashboard from '@/components/Dashboard'
import SuperLogin from '@/components/SuperLogin'

import Charts from '@/components/pages/Charts'
// auth
import ConfirmSignup from '@/components/auth/ConfirmSignup'
import Login from '@/components/auth/Login'
import NewPassword from '@/components/auth/NewPassword'
import ResetPassword from '@/components/auth/ResetPassword'
import ResetPasswordForm from "@/components/auth/ResetPasswordForm"

import ResetPasswordVerification from '@/components/auth/ResetPasswordVerification'
import Signup from '@/components/auth/Signup'
import Signup2 from '@/components/auth/Signup2'
import Verification from '@/components/auth/Verification'

// classes
import Classes from '@/components/classes/Classes'
import CreateClass from '@/components/classes/CreateClass'
// import SelectTime from '@/components/classes/SelectTime.vue'
import Viewclass from '@/components/classes/Viewclass'
import EditClass from '@/components/classes/EditClass'

// error
import ErrorPage from '@/components/error/404'

// package
import Packages from '@/components/package/Packages'
import CreatePackage from '@/components/package/CreatePackage'
import ViewPackage from '@/components/package/ViewPackage.vue'
import StudentViewPack from '@/components/package/StudentViewPack.vue'
import EditPackage from '@/components/package/EditPackage'


// pages
  // sasee
import GoToBooking from '@/components/pages/sasee/GoToBooking.vue'
import Invoice from '@/components/pages/sasee/Invoice'

  // student
import AddNewStudent from '@/components/pages/student/AddNewStudent'
import EditStudent from '@/components/pages/student/EditStudent'
import EditStudentprofile from '@/components/profile/student/EditStudent'
import Students from '@/components/pages/student/Students'

  // teacher
import AddNewTeacher from '@/components/pages/teacher/AddNewTeacher'
import TeacherSchedule from '@/components/pages/teacher/TeacherSchedule'
import ConfirmTeacherClasses from '@/components/pages/teacher/ConfirmTeacherClasses'
import Teachers from '@/components/pages/teacher/Teachers'


import AddClasses from '@/components/pages/AddClasses'
import BlockList from '@/components/pages/BlockList'
import Settings from '@/components/pages/Settings'
import Home from '@/components/pages/Home'
import TotalEarnings from '@/components/pages/TotalEarnings'

// Adminprofile
import AdminProfile from '@/components/profile/admin/AdminProfile'
import Chat from '@/components/pages/Chat'
import AdminCalender from '@/components/pages/AdminCalender'
import Widset from '@/components/pages/Widset'
import ChatList from '@/components/chat/ChatList'
import Chats from '@/components/chat/Chats'

// Teacherprofile
import TeacherProfile from '@/components/profile/teacher/TeacherProfile'

// Studentprofile
import StudentProfile from '@/components/profile/student/StudentProfile'
import MyClasses from '@/components/profile/student/new/MyClasses'
import practicalbook from '@/components/profile/student/new/practicalbook'
import theorybook from '@/components/profile/student/new/theorybook'

// test
import Notification from '@/components/test/Notification.vue'
import NotificationClick from '@/components/test/NotificationClick'
import NotificationWithoutClick from '@/components/test/NotificationWithoutClick'
import TestSignup from '@/components/test/testSignup'
import Test from '@/components/test/test'
import SettingsLists from '@/components/test/SettingsLists'
import CalenderSinglePage from '@/components/test/CalenderSinglePage.vue'
import NewCalender from '@/components/test/NewCalender'
import CreateEvent from '@/components/test/CreateEvent'
import EditEvent from '@/components/test/EditEvent'
import EditProfile from '@/components/profile/admin/EditProfile'
import EditTeacher from '@/components/profile/teacher/EditTeacher'
import EditTeacherList from '@/components/pages/teacher/EditTeacher'
import ConfirmMail from '@/components/ConfirmMail'
import FreeSlots from '@/components/pages/teacher/FreeSlots'


import auth from '@/utils/auth'

function requireAuth(to, from, next) {
  if (!auth.loggedIn()) {
    next({
      path: '/login',
      query: {
        redirect: to.fullPath
      }
    })
  } else {
    next()
  }
}

Vue.use(Router)


export default new Router({
  //mode:'history',
  routes: [
    { path: '/404', component: ErrorPage, name: 'ErrorPage' },
    { path: '*', redirect: '/404' },
    {
      path: '/confirmation/:id',
      component: ConfirmMail,
      name: 'confirmation',
      props: true
    },
    {
      path: '/verification/:id',
      component: ConfirmMail,
      name: 'verification',
      props: true
    },
    {
      path: '/',
      name: 'Dashboard',
      component: Dashboard,
      beforeEnter:requireAuth,
      children: [
        {
          path: '',
          component: Home,
          beforeEnter: requireAuth
        },
        {
          path: 'MyClasses',
          component: MyClasses,
        },
        {
          path: 'practicalbook',
          component: practicalbook,
        },
        {
          path: 'theorybook',
          component: theorybook,
        },
        {
          path: 'students',
          component: Students,
          beforeEnter: requireAuth
        },
        {
          path: 'TotalEarnings',
          component: TotalEarnings,
          beforeEnter: requireAuth
        },
        {
          path: 'teachers/edit/:id',
          component: EditTeacher,
          beforeEnter: requireAuth,
          props:true
        },
        {
          path: 'teachers/Lists/edit/:id',
          component: EditTeacherList,
          beforeEnter: requireAuth,
          props:true
        },
          {
              path: 'admin/edit/:id',
              component: EditProfile,
              beforeEnter: requireAuth,
              props:true
          },
        {
          path: 'Charts',
          component: Charts,
          beforeEnter: requireAuth
        },
        {
          path: 'BlockList',
          component: BlockList,
          beforeEnter: requireAuth
        },
        {
          path: 'Settings',
          component: Settings,
          beforeEnter: requireAuth
        },
        {
          path: '/teachers',
          component: Teachers,
          beforeEnter: requireAuth
        },
        {
          path: '/classes',
          name: 'Classes',
          component: Classes,
          beforeEnter: requireAuth
        },
        {
          path: '/Packages',
          name: 'Packages',
          component: Packages,
          beforeEnter: requireAuth
        },
        {
          path: '/viewclass/:id',
          name: 'Viewclass',
          component: Viewclass,
          beforeEnter: requireAuth,
          props: true
        },
        {
          path: 'adminprofile',
          component: AdminProfile,
          beforeEnter: requireAuth
        },
        {
          path: 'admincalender',
          component: AdminCalender,
          beforeEnter: requireAuth
        },
        {
          path: 'widset',
          component: Widset,
          beforeEnter: requireAuth
        },
        {
          path: 'chat',
          component: Chat,
          beforeEnter: requireAuth
        },
        {
          path: 'chatlist',
          component: ChatList,
          beforeEnter: requireAuth
        },
        {
          path: 'chats/:id/:type',
          component: Chats,
          beforeEnter: requireAuth,
          props:true
        },
        {
          path: '/teacherprofile/:id',
          component: TeacherProfile,
          beforeEnter: requireAuth,
          props:true
        },
        {
          path: '/studentprofile/:id',
          component: StudentProfile,
          beforeEnter: requireAuth,
          props:true
        },
        {
          path: '/notification',
          component: Notification,
          beforeEnter: requireAuth
        },
        {
          path: 'addclasses',
          component: AddClasses,
          beforeEnter: requireAuth
        },
        {
          path: 'ConfirmSignup',
          component: ConfirmSignup,
          beforeEnter: requireAuth
        },
        {
          path: 'invoice',
          component: Invoice,
          beforeEnter: requireAuth
        },
        {
          path: 'test',
          component: Test
        },
        {
          path: 'SettingsLists',
          component: SettingsLists
        },
        {
          path: 'ConfirmTeacherClasses',
          component: ConfirmTeacherClasses,
          beforeEnter: requireAuth
        },
        {
          path: 'viewpackage/:id',
          component: ViewPackage,
          beforeEnter: requireAuth
        },
        {
          path: 'StudentViewPack/:id',
          component: StudentViewPack,
          beforeEnter: requireAuth,
        },
        {
          path: 'createpackage',
          component: CreatePackage,
          beforeEnter: requireAuth
        },
        {
          path: '/editpackage/:id',
          component: EditPackage,
          beforeEnter: requireAuth
        },
        {
          path: 'CreateClass',
          component: CreateClass,
          beforeEnter: requireAuth
        },
        {
          path: '/editclass/:id',
          component: EditClass,
          beforeEnter: requireAuth,
          props:true
        },
        // {
        //   path: 'SelectTime',
        //   component: SelectTime
        // },
        {
          path: 'GoToBooking',
          component: GoToBooking,
          beforeEnter: requireAuth
        },
        {
          path: 'CalenderSinglePage',
          component: CalenderSinglePage,
          beforeEnter: requireAuth
        },
        {
          path: '/NewCalender/:teacherId',
          component: NewCalender,
          props:true,
          beforeEnter: requireAuth
        },
        {
          path: 'CreateEvent/:id',
          props:true,
          component: CreateEvent,
          beforeEnter: requireAuth
        },
        {
          path: 'EditEvent/:id/:teacherId',
          component: EditEvent,
          props:true,
          beforeEnter: requireAuth
        },
        {
          path: 'AddNewTeacher',
          component: AddNewTeacher,
          beforeEnter: requireAuth
        },
        {
          path: 'TeacherSchedule',
          component: TeacherSchedule,
          beforeEnter: requireAuth
        },
        {
          path: 'AddNewStudent',
          component: AddNewStudent,
          beforeEnter: requireAuth
        },
        {
          path: 'students/edit/:id',
          component: EditStudent,
          beforeEnter: requireAuth
        },
        {
          path: 'students/profile/edit/:id',
          component: EditStudentprofile,
          beforeEnter: requireAuth
        },
        {
          path: '/FreeSlots/:id/:teacherId',
          name: 'FreeSlots',
          component: FreeSlots,
          props:true,
          beforeEnter:requireAuth
        }

      ]
    },
    // navication side & out of dashboard components
    {
      path: '/testsignup',
      name: 'TestSignup',
      component: TestSignup
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      beforeEnter:(to,from,next)=>{
        try{
          let expireDate =new Date(Store.state.expireDate)
          let role =Store.state.user.role
          // debugger
          console.log("before Login")
          let date= new Date()
          let diff=expireDate-date
          if(diff>1000){
              next('/')
          }else{
            next()
          }
        }catch(err){
          next()
        }
      }
    },
    {
      path: '/superlogin/:id/:su_token',
      name: 'SuperLogin',
      props:true,
      component:SuperLogin
      // beforeEnter:(to,from,next)=>{
        // console.log("superlogin")
      //   try{
      //     let expireDate =new Date(Store.state.expireDate)
      //     let role =Store.state.user.role
      //     // debugger
      //     console.log("before Login")
      //     let date= new Date()
      //     let diff=expireDate-date
      //     if(diff>1000){
      //         next('/')
      //     }else{
      //       next()
      //     }
      //   }catch(err){
          // next()
      //   }
      // }
    },
    {
      path: '/signup',
      name: 'Signup',
      component: Signup
    },
    {
      path: '/complete',
      name: 'Signup2',
      component: Signup2
    },
    {
      path: '/complete/:id',
      name: 'Signup2',
      component: Signup2,
      props:true
    },
    {
      path: '/changepackage/:packId',
      name: 'Signup2',
      component: Signup2,
      props:true
    },
    {
      path: '/resetpassword',
      name: 'ResetPassword',
      component: ResetPassword
    },
    {
      path: "/resetpassword/:token",
      component: ResetPasswordForm,
      props:true
    },
    {
      path: '/newpassword',
      name: 'NewPassword',
      component: NewPassword
    },
    {
      path: '/verification',
      name: 'Verification',
      component: Verification
    },
    // {
    //   path: '/resetPasswordVerification',
    //   name: 'ResetPasswordVerification',
    //   component: ResetPasswordVerification
    // },
    {
      path: '/notificationwithoutclick',
      component: NotificationWithoutClick
    },
    {
      path: '/notificationclick',
      component: NotificationClick
    },
    {
      path: '/firstPackages',
      name: 'Packages',
      component: Packages,
      beforeEnter: requireAuth
    },
    {
      path: '/logout',
      beforeEnter(to, from, next) {
        auth.logout()
        next('/login')
      }
    },

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js